<div class="title">Token Assets</div>
<div id="token-assets" (mouseout)="hoverId = undefined">
    <img *ngFor="let token of tokens" width="50" [src]="'https://' + token.src" crossorigin="anonymous" draggable="true" class="idle-token" [attr.tokenId]="token.id" (mouseover)="hoverId = token.id">
</div>
<input type="file" id="upload-button" accept="image/*" style="display: none;" (change)="uploadFile($event)" />
<label id="upload-label" for="upload-button">
    <div>Click or Drag+Drop</div>
    <div>to Upload</div>
</label>
